import type { MutableRefObject } from 'react'
import { useEffect, useState } from 'react'
import { useWindowSize } from './useWindowSize'

export function useElementOverflow(
  ref: MutableRefObject<HTMLElement | null>,
  ...dependencies: unknown[]
): boolean {
  const [overflowing, setOverflowing] = useState(() => false)
  const windowSize = useWindowSize(ref)

  useEffect(() => {
    const el = ref.current

    if (el) {
      setOverflowing(
        el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight,
      )
    }
  }, [ref, windowSize.height, windowSize.width, dependencies])

  return overflowing
}
